import { RiskPolicy } from "@design-controls/types";

export const riskScore = (
  policy: RiskPolicy,
  probability?: string,
  severity?: string,
) => {
  if (!probability || !severity) {
    return;
  }

  const probabilityIndex = policy.assessment.iso.probability.findIndex(
    (p) => p === probability,
  );

  const severityIndex = policy.assessment.iso.severity.findIndex(
    (s) => s === severity,
  );

  if (probabilityIndex === -1 || severityIndex === -1) {
    return undefined;
  }

  return policy.assessment.iso.levelMapping[probabilityIndex][severityIndex];
};
